var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modal)?_c('div',{staticClass:"modal-container"},[_c('section',{staticClass:"modal",class:{ show: _vm.show }},[_c(_vm.modal.modal,{tag:"component",attrs:{"data":_vm.modal.data},on:{"close":_vm.close}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }